/* eslint-disable no-unused-vars */
import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout/index'
import LayoutContent from '@/layout/index-content'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    { // 根目录
      path: '/',
      redirect: '/welcome'
    },

    { // 欢迎页
      name: 'welcome',
      path: '/welcome',
      component: () => import('@/views/welcome/index.vue'),
      hidden: true
    },

    { // 登录页
      name: 'login',
      path: '/login',
      component: () => import('@/views/login/index.vue')
    },

    { // 首页
      path: '/dashboard',
      component: Layout,
      children: [{
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('@/views/dashboard/index.vue')
      }]
    },
    { // 操作指南
      path: '/handbook',
      component: () => import('@/views/dashboard/handbook.vue'),
      handle: true
    },

    { // 店铺管理
      path: '/shop',
      component: Layout,
      children: [{
        path: '/shop/shopee',
        name: 'Shopee-Shop',
        component: () => import('@/views/shop/shopee.vue')
      }, {
        path: '/shop/tiktok',
        name: 'Tiktok-Shop',
        component: () => import('@/views/shop/tiktok.vue')
      }]
    },
    { // 添加店铺的重定向页面
      name: 'Shop Impower',
      path: '/shopImpower',
      component: () => import('@/views/redirect/shop-impower.vue'),
      hidden: true
    },
    { // 添加店铺的重定向页面
      name: 'Tiktok Shop Impower',
      path: '/tiktokShopImpower',
      component: () => import('@/views/redirect/tiktok-shop-impower.vue'),
      hidden: true
    },
    { // SKU编码指南
      path: '/skuNumber',
      component: () => import('@/views/shop/skuNumber.vue'),
      handle: true
    },

    { // 订单管理
      path: '/order',
      component: Layout,
      children: [{
        path: '/order',
        name: 'Order',
        component: () => import('@/views/order/index.vue')
      }]
    },

    { // 出库管理
      path: '/outbound',
      component: Layout,
      children: [{
        path: '/outbound',
        name: 'Outbound',
        component: () => import('@/views/outbound/index.vue')
      }, { // 出库详情
        path: '/outbound/detail',
        name: 'Outbound-detail',
        component: () => import('@/views/outbound/outbound-detail.vue')
      }]
    },

    { // 入库管理
      path: '/inbound',
      component: Layout,
      children: [{
        path: '/inbound',
        name: 'Inbound',
        component: () => import('@/views/inbound/index.vue')
      }, { // 入库详情
        path: '/inbound/detail',
        name: 'Inbound-detail',
        component: () => import('@/views/inbound/inbound-detail.vue')
      }]
    },

    { // 商品管理
      path: '/sku',
      component: Layout,
      children: [{
        path: '/sku',
        name: 'Sku',
        component: () => import('@/views/sku/index.vue')
      }, { // sku详情
        path: '/sku/detail',
        name: 'Sku-detail',
        component: () => import('@/views/sku/sku-detail.vue')
      }]
    },

    { // 仓库列表
      path: '/warehouse',
      component: Layout,
      children: [{
        path: '/warehouse',
        component: () => import('@/views/warehouse/index.vue')
      }]
    },

    { // 库存中心
      path: '/store',
      component: Layout,
      children: [{
        path: '/store',
        component: () => import('@/views/store/index.vue')
      }]
    },

    { // 充值中心
      path: '/recharge',
      component: LayoutContent,
      children: [{
        path: '/recharge',
        name: 'Recharge',
        component: () => import('@/views/recharge/index.vue')
      }]
    },
    { // 充值后的重定向页面
      name: 'Recharge Redirect',
      path: '/rechargeRedirect',
      component: () => import('@/views/redirect/recharge-redirect.vue'),
      hidden: true
    },

    { // 交易记录
      path: '/dealRecords',
      component: LayoutContent,
      children: [{
        path: '/dealRecords',
        name: 'Deal Records',
        component: () => import('@/views/deal-records/index.vue')
      }]
    },

    { // 用户管理
      path: '/userManage',
      component: LayoutContent,
      children: [{
        path: '/userManage',
        name: 'User Manage',
        component: () => import('@/views/user-manage/index.vue')
      }]
    },

    { // 设置模块
      path: '/setting',
      component: LayoutContent,
      children: [{
        path: '/setting',
        name: 'Setting',
        component: () => import('@/views/_setting/index.vue')
      }]
    },

    // 错误页面
    {
      path: '*',
      redirect: '/404'
    },
    // 404
    {
      path: '/404',
      component: () => import('@/views/error/404.vue')
    }

    // // 维护页面 当进入维护状态时，注销以上除【welcome】页面的所有路由导航，并开放以下路由代码
    // {
    //   path: '*',
    //   redirect: '/repair'
    // },
    // {
    //   path: '/repair',
    //   component: () => import('@/views/error/repair.vue')
    // }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js